import $ from 'jquery';
import L from 'leaflet';
//import 'leaflet/dist/leaflet.css';


const map = {
	view: null,
	routeView: null,

	// Carte multi-points ("Your day at a glance") : marqueurs numerotes en
	// DivIcon (cf. .__route_marker, meme langage visuel que les puces de la
	// timeline) plutot que le pin par defaut, relies par un trace elegant -
	// initialisee une seule fois (bouton "View itinerary on map" ne fait que
	// l'afficher/la cacher ensuite, cf. product.js initItineraryMap()).
	initRoute(containerId, points, controlsScope) {
		if (this.routeView || !points || points.length < 2) {
			return;
		}

		this.routeView = L.map(containerId, {
			zoomControl: false,
			scrollWheelZoom: false
		});

		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			maxZoom: 19,
			attribution: '&copy; OpenStreetMap'
		}).addTo(this.routeView);

		const latLngs = points.map((p) => [p.lat, p.lng]);

		this.routeBounds = L.latLngBounds(latLngs);
		this.routeView.fitBounds(this.routeBounds, {padding: [30, 30]});

		// Deux etapes peuvent partager exactement les memes coordonnees (ex.
		// lieu de depart et de retour, ou un texte de lieu trop vague resolu
		// au meme point) - un leger decalage en cercle autour du point reel
		// les separe visuellement pour rester cliquables individuellement.
		// Calcule en PIXELS (converti en lat/lng une fois le zoom fixe par
		// fitBounds ci-dessus) plutot qu'en degres fixes, sinon l'ecart est
		// invisible sur un trace qui couvre une grande distance (le zoom est
		// alors trop large pour qu'un delta constant en degres se voie) -
		// cf. retours utilisateur ("je vois deux points au lieu de 4").
		const groups = new Map();
		points.forEach((point, index) => {
			const key = point.lat.toFixed(4) + ',' + point.lng.toFixed(4);
			if (!groups.has(key)) {
				groups.set(key, []);
			}
			groups.get(key).push(index);
		});

		const pixelRadius = 16;
		const markerLatLngs = points.map((point) => L.latLng(point.lat, point.lng));
		groups.forEach((indexes) => {
			if (indexes.length < 2) {
				return;
			}
			const center = this.routeView.latLngToLayerPoint(markerLatLngs[indexes[0]]);
			indexes.forEach((pointIndex, i) => {
				const angle = (2 * Math.PI * i) / indexes.length;
				const offsetPoint = L.point(
					center.x + pixelRadius * Math.cos(angle),
					center.y + pixelRadius * Math.sin(angle)
				);
				markerLatLngs[pointIndex] = this.routeView.layerPointToLatLng(offsetPoint);
			});
		});

		// Le trace suit les positions decalees des marqueurs (pas les
		// coordonnees d'origine) : sinon les segments entre deux etapes aux
		// coordonnees identiques (1->2, 3->4 ici) sont invisibles et le
		// "circuit" ne se lit plus comme reliant les 4 points dans l'ordre -
		// cf. retours utilisateur ("tout le circuit avec le trace 1-2-3-4").
		L.polyline(markerLatLngs, {
			color: '#895BED',
			weight: 3,
			opacity: .85,
			dashArray: '1, 10',
			lineCap: 'round'
		}).addTo(this.routeView);

		points.forEach((point, index) => {
			const label = point.num || (index + 1);
			const icon = L.divIcon({
				className: '__route_marker',
				html: `<span>${label}</span>`,
				iconSize: [28, 28],
				iconAnchor: [14, 14]
			});

			L.marker(markerLatLngs[index], {icon})
				.bindPopup(`<strong>${label}.</strong> ${point.title || ''}`, {closeButton: false})
				.addTo(this.routeView);
		});

		this.bindRouteControls(controlsScope);
	},

	bindRouteControls(scope) {
		const $scope = scope ? $(scope) : $(document);

		$scope.find("[data-itinerary-zoom-in]").on("click", () => {
			this.routeView.setZoom(this.routeView.getZoom() + 1);
		});

		$scope.find("[data-itinerary-zoom-out]").on("click", () => {
			this.routeView.setZoom(this.routeView.getZoom() - 1);
		});

		$scope.find("[data-itinerary-center]").on("click", () => {
			this.routeView.fitBounds(this.routeBounds, {padding: [30, 30]});
		});
	},

	refreshRoute() {
		if (this.routeView) {
			this.routeView.invalidateSize();
		}
	},

	init(lat, lng) {
		const markerIcon = L.icon({
			iconUrl: `${_URL}img/SITE/GENERAL/__icon_marker.png?v=1`,
			iconSize: [50, 66],
			iconAnchor: [22, 94]
		});

		this.view = L.map('__map', {
			center: [lat, lng],
			zoom: 14,
			zoomControl: false
		});

		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			maxZoom: 19,
			attribution: '&copy; OpenStreetMap'
		}).addTo(this.view);

		L.marker([lat, lng], {
			icon: markerIcon,
			title: "Meeting point"
		}).addTo(this.view);

		this.bindControls(lat, lng);
	},

	bindControls(lat, lng) {
		$(document).on("click", ".__zoom_plus", () => {
			const zoom = this.view.getZoom();
			this.view.setZoom(zoom + 1);
		});

		$(document).on("click", ".__zoom_minus", () => {
			const zoom = this.view.getZoom();
			this.view.setZoom(zoom - 1);
		});

		$(document).on("click", ".__map_center", () => {
			const target = L.latLng(lat, lng);
			this.view.setView(target, 15);
			this.view.panTo(target);
		});
	}
};

export default map;
